import KunLoading32 from './src/index'

KunLoading32.install = function (Vue) {
	Vue.component(KunLoading32.name, KunLoading32);
}

export default KunLoading32;
